import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

export interface CalendarEvent {
  id?: string;
  calendarId: string;
  title: string;
  description?: string;
  start_date: Date | string;
  end_date?: Date | string;
  all_day?: boolean;
  status?: string;
  type?: string;
  linkedId?: string;
  linkedType?: string;
  extendedProps?: any;
}

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  private http = inject(HttpClient);

  private apiUrl = (environment.api_gateway && environment.api_gateway !== 'undefined' ? environment.api_gateway : 'http://localhost:3000') + '/api/commons/calendars';

  constructor() { }

  async getCalendars(userId?: string) {
    const url = userId ? `${this.apiUrl}?userId=${userId}` : this.apiUrl;
    return firstValueFrom(this.http.get<any[]>(url));
  }

  async getEvents(calendarId: string, options: { start?: string; end?: string; status?: string } = {}) {
    let url = `${this.apiUrl}/${calendarId}/events`;
    const params = new URLSearchParams();
    if (options.start) params.set('start', options.start);
    if (options.end) params.set('end', options.end);
    if (options.status) params.set('status', options.status);
    
    const query = params.toString();
    if (query) url += `?${query}`;

    return firstValueFrom(this.http.get<CalendarEvent[]>(url));
  }

  async createEvent(event: CalendarEvent) {
    return firstValueFrom(this.http.post<CalendarEvent>(`${this.apiUrl}/${event.calendarId}/events`, event));
  }

  async updateEvent(id: string, event: Partial<CalendarEvent>) {
    return firstValueFrom(this.http.patch<CalendarEvent>(`${this.apiUrl}/events/${id}`, event));
  }

  async deleteEvent(id: string) {
    return firstValueFrom(this.http.delete<any>(`${this.apiUrl}/events/${id}`));
  }
}
